import { api } from '..';
import { VersionData } from './types';

export const reportApi = api.enhanceEndpoints({ addTagTypes: ['Version'] }).injectEndpoints({
  endpoints: build => ({
    getVersion: build.query<VersionData, any>({
      query: () => ({
        url: `v1/version`,
        method: 'GET',
      }),
    }),
    getLoyaltyVersion: build.query<any, any>({
      query: () => ({
        url: `v1/loyalty/version`,
        method: 'GET',
      }),
      transformResponse: (res: any) => {
        return res.version;
      },
    }),
    getNp6Version: build.query<any, any>({
      query: () => ({
        url: `v1/np6/version`,
        method: 'GET',
      }),
      transformResponse: (res: any) => {
        return res.version;
      },
    }),
  }),
});

export const { useLazyGetVersionQuery, useGetLoyaltyVersionQuery, useGetNp6VersionQuery } = reportApi;
